module.exports = __webpack_public_path__ + "img/qrcode_frame_1.7299bdfd.png";